import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { FETCH_COMPONENTS_REASON } from '../../common/constants/fetch-components-reason.tsx';
import type { OrderField, OrderDirection } from '../../query-param-adapter/model/order.tsx';
import { getComponentsPageRequest } from '../../state/actions.tsx';
import { getIds as getComponentIds } from '../../state/components/selectors.tsx';
import { isAdmin } from '../../state/context/selectors.tsx';
import { patchQuery } from '../../state/query/actions.tsx';
import { getOrderDirection, getOrderField, getFilter } from '../../state/query/selectors.tsx';
import type { State } from '../../state/reducer.tsx';
import { isLoading as isPageLoading } from '../../state/ui/page/selectors.tsx';
import TableView from './view.tsx';

const mapStateToProps = (state: State) => ({
	componentIds: getComponentIds(state),
	isLoading: isPageLoading(state),
	editable: isAdmin(state),
	orderField: getOrderField(state),
	orderDirection: getOrderDirection(state),
	query: getFilter(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	onSort: ({ key, sortOrder }: { key: OrderField; sortOrder: OrderDirection }) => {
		dispatch(
			patchQuery({
				orderDirection: sortOrder,
				orderField: key,
				page: 1,
			}),
		);
		dispatch(
			getComponentsPageRequest({
				page: 1,
				initiatedBy: FETCH_COMPONENTS_REASON.SORTING,
			}),
		);
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(TableView);
